'use es6';

import { handleActions } from 'flux-actions';
import { PORTAL_AUTH_SUCCEEDED } from '../actions/ActionTypes';
export default handleActions({
  [PORTAL_AUTH_SUCCEEDED](state, action) {
    return action.payload;
  }

}, null);